import { NoddiTooltip } from 'noddi-ui-web';

type Props = {
  label: string;
  description: string;
};

export const ImpersonationTableHeader = ({ label, description }: Props) => (
  <span className='flex items-center gap-1'>
    {label}
    <NoddiTooltip content={description} label={`About ${label}`} />
  </span>
);
